import { Component, ViewChild } from '@angular/core';
import { IonicPage, Platform, NavController, ModalController, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { HelperService } from '../../providers/providers';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Device } from '@ionic-native/device/ngx';
import { EventLoggerProvider } from '../../providers/event-logger/event-logger';
import { AppVersion } from '@ionic-native/app-version/ngx';


@IonicPage()
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html'
})
export class WelcomePage {

  public showError: boolean = false;
  public errorMsg: string = '';
  public appVersion;
  public showSignUpBtn: boolean = true;
  public loginForm: FormGroup;
  public selectedLang: string = '';
  private _deviceInfo: any = {};
  @ViewChild('contentWrapper') contentWrapper: any;

  constructor(logger: EventLoggerProvider, _device: Device, formBuilder: FormBuilder, private platform: Platform,
    private storage: Storage, private helperService: HelperService, private navCtrl: NavController, private modalCntrl: ModalController,
    private loadingCntrl: LoadingController, appVersion: AppVersion) {
    this.loginForm = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      terms_conditions: [false, Validators.pattern('true')]
    });

    platform.ready().then(() => {
      // if (this.platform.is("cordova")) {
      //   // Logging Page View to Firebase Analytics
      //   // logger.logPageView('WelcomePage');

      //   this._deviceInfo.uuid = _device.uuid
      //   this._deviceInfo.os = _device.platform + '-' + _device.version
      //   this._deviceInfo.device = _device.manufacturer + '/' + _device.model + '/' + _device.serial
      //   this.loginForm.controls.terms_conditions.setValue(false);

      //   appVersion.getVersionNumber().then(data => {
      //     this.appVersion = data;
      //   }, error => { });

      // }
      this._deviceInfo.os = "Android";
      this._deviceInfo.device = "AnydevicePro";
      this.storage.get("selected_lang").then((lang) => {
        this.selectedLang = lang.toLowerCase();
      }).catch((err) => {
        window.onerror("welcome page getting selected language error : " + JSON.stringify(err), window.location.href, 55, 0);
        this.selectedLang = "EN"
      });
    });

  }

  create_UUID() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  showTerms() {
    let modal = this.modalCntrl.create('TermsConditionsPage', { 'isChecked': this.loginForm.controls.terms_conditions.value, 'showCheckBox': true, 'selectedLang': this.selectedLang }, { enableBackdropDismiss: true, cssClass: 'terms-condition-modal' });
    modal.present();
    modal.onDidDismiss(data => {
      this.loginForm.controls.terms_conditions.setValue(data.aggreed);
    })
  }

  openSessionPage() {

    this.platform.ready().then(() => {
      let loader = this.loadingCntrl.create({ content: "Signin is process..." });
      loader.present();

      if (this.loginForm.valid) {

        this.storage.get(this.loginForm.value.email).then((uuid) => {

          // if (existuser && this.loginForm.value.email && existuser.email == this.loginForm.value.email && existuser.uuid && existuser.uuid != "")
          if (uuid)
            this._deviceInfo.uuid = uuid;

          else
            this._deviceInfo.uuid = this.create_UUID();

        }).catch((err) => {
          window.onerror("welcome page getting email token error : " + JSON.stringify(err), window.location.href, 98, 0);
          this._deviceInfo.uuid = this.create_UUID();
        });

        setTimeout(() => {

          this.storage.set('email', this.loginForm.value.email).then(() => { }).catch((err) => {
            window.onerror("welcome page save email error : " + JSON.stringify(err), window.location.href, 105, 0);
          });
          this.storage.set(this.loginForm.value.email, this._deviceInfo.uuid).then(() => { }).catch((err) => {
            window.onerror("welcome page save email token error : " + JSON.stringify(err), window.location.href, 108, 0);
          });

          this.helperService.loginUser({ email: this.loginForm.value.email, deviceInfo: this._deviceInfo }).subscribe(response => {

            this.storage.set('visitor_id', response).then(() => {

              loader.dismiss();
              this.navCtrl.setRoot('JoinSessionPage');

            }, OnError => {
              loader.dismiss();
              this.displayError(OnError);
            });

          }, (err) => {
            window.onerror("welcome page login user server error : " + JSON.stringify(err), window.location.href, 124, 0);
          });

        }, 300);

      }

    })

  }

  ionViewDidEnter() {
    if (this.platform.is("ios") || this.platform.is("tablet"))
      this.contentWrapper._elementRef.nativeElement.childNodes[1].classList.add("iosContent");

    window.addEventListener('keyboardWillShow', (event) => {
      if (this.platform.is("tablet"))
        this.contentWrapper._elementRef.nativeElement.childNodes[1].classList.add("tabletContent");
    });

    window.addEventListener('keyboardWillHide', () => {
      if (this.platform.is("tablet"))
        this.contentWrapper._elementRef.nativeElement.childNodes[1].classList.remove("tabletContent");
    });

  }

  displayError(message: string) {
    this.showError = true;
    this.errorMsg = message;
  }


  showSignUp() {
    let signUpModal = this.modalCntrl.create('SignUpPage', null, { enableBackdropDismiss: true, cssClass: 'signup-modal ' });
    signUpModal.onDidDismiss(data => {
      if (data == 1) {
        this.platform.ready().then(() => {
          this.storage.get('user_email').then(data => {
            if (data)
              this.showSignUpBtn = false;
          }, err => {
            window.onerror("welcome page getting user email error : " + JSON.stringify(err), window.location.href, 166, 0);
            this.showSignUpBtn = true
          });
        })
      }
    })
    signUpModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts